import service from '@/services/superaccess'

const reload = {
  state: {
    reload_modal: false
  },
  mutations: {
    updateStatusReloadModal (state, status) {
      state.reload_modal = status
    }
  },
  getters: {
    getStatusReloadModal (context) {
      return context.reload_modal
    }
  },
  actions: {
    setStatusReloadModal (context, payload) {
      context.commit('updateStatusReloadModal', payload)
    },
    reloadNetwork (context, payload) {
      console.log('Aqui...')
      return service.get('/api/networks/reload', context)
    },
    rebootServer (context, payload) {
      return service.get('/api/configuration/reboot', context)
    },
    restartWebServer (context, payload) {
      return service.get('/api/configuration/reload', context)
    }
  }
}

export default reload



// WEBPACK FOOTER //
// app/javascript/src/store/reload.js